<template>
  <div style=" height: content-box">
    <el-header style="font-size: 12px; ">
      <el-tabs >
        <el-tab-pane v-for="item in pageData" :key="item.id" :label="item.name">
          <component :is="item.content" :itemData="item.data"></component>
        </el-tab-pane>
      </el-tabs>
    </el-header>
  </div>
</template>

<script>
import spgl from "./spsgl.vue";
import spflgl from "./spsflgl.vue";
export default {
  data() {
    return {
      pageData: [
        {
          id: "t01",
          name: "基础实验得分",
          content: "spgl",
          data: "基础实验得分"
        },
        /*{
          id: "t02",
          name: "视频栏目管理",
          content: "spflgl",
          data: "视频栏目管理"
        }*/
      ]
    }
  },
  components: {
    spgl,
    spflgl
  },
  props: ["itemData"]
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/sp/index.vue